var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2593 0.925781C5.77733 0.925781 0.530029 6.48176 0.530029 13.341C0.530029 18.3482 2.17624 19.7429 11.0589 33.3699C11.642 34.2616 12.8881 34.2616 13.4711 33.3699C22.3538 19.7429 24 18.3482 24 13.341C23.9886 6.48176 18.7413 0.925781 12.2593 0.925781Z",
    fill: "#0040BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9337 15.959C15.6419 18.5426 12.5095 19.5829 9.91446 18.2911C7.33082 16.9993 6.2905 13.8669 7.58232 11.2718L9.94876 6.57324L10.4403 6.83618C10.5661 6.92764 10.7033 7.01909 10.8405 7.14484C11.8236 7.89936 12.6696 8.80249 13.3898 9.81995C14.6816 11.832 14.5559 13.2153 14.956 13.261C15.4018 13.3067 16.1221 12.0949 16.5679 10.6202C17.654 12.2092 17.7797 14.267 16.9337 15.959Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;